import { FocusNode } from '@please/lrud'
import styled, { css } from 'styled-components'

import bgImg from '@/assets/bg/settings-bg.png'
import { icons } from '@/constants/icons'
import { defaultScrollHeight } from '@/constants/scrollers'
import { ScrollContainerType } from '@/types/sliderTypes'

export const Container = styled(FocusNode)`
  position: relative;
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
`

export const BackgroundImage = styled.div<{ $isFixedPosition?: boolean }>`
  position: ${({ $isFixedPosition }) =>
    $isFixedPosition ? 'fixed' : 'absolute'};
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  min-height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 0% 0%;
    opacity: 0;
    transition: all 0.2s ease-out;
    &.isVisible {
      opacity: 1;
    }
  }
`

export const SettingsContainer = styled(FocusNode)`
  height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 96px 0 528px;
  background-image: url(${bgImg});
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: auto 900px;
  position: relative;
`

export const ScrollContainer = styled.div<ScrollContainerType>`
  position: relative;
  height: ${({ height }) =>
    height ? `${height}px` : `${defaultScrollHeight}px`};
  overflow: hidden;
  padding-bottom: ${({ $paddingBottom }) =>
    $paddingBottom ? `${$paddingBottom}px` : '0'};
  ${({ $withMargin }) =>
    $withMargin &&
    css`
      margin-left: -24px;
      padding-left: 24px;
    `}
`

export const ErrPageContainer = styled(FocusNode)<{
  $fullScreenMode?: boolean
}>`
  display: flex;
  flex-direction: column;
  height: 50vh;
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 112px;
  margin-left: ${({ $fullScreenMode }) => ($fullScreenMode ? '0' : '380px')};
  background-image: url(${bgImg});
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: auto 900px;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.text};
`
export const ErrPageCode = styled.div`
  opacity: 0.1;
  font-size: 100px;
`

export const Title = styled.h1`
  font-size: 40px;
  line-height: 30px;
  color: ${(props) => props.theme.colors.title};
  font-weight: 500;
  text-transform: uppercase;
  padding-bottom: 10px;
`

export const BodyText = styled.div`
  font-size: 20px;
  color: ${(props) => props.theme.colors.text};
  opacity: 0.9;
  line-height: 1.5em;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 15;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-height: 22.5em;

  a {
    color: ${(props) => props.theme.colors.link};
  }
`

export const TextElem = styled(FocusNode)`
  height: 800px;
  padding-right: 20px;
  margin-bottom: 20px;
  overflow-y: auto;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  white-space: pre-line;
  &.isFocusedLeaf {
    box-shadow: none;
  }
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
  }

  &.isFocused::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.title};
  }
`

export const HTMLWrapper = styled.div`
  font-size: 20px;
  color: ${(props) => props.theme.colors.text};
  opacity: 0.9;
  line-height: 30px;
  font-weight: 500;
  white-space: normal;
  p,
  h1,
  h2,
  h3 {
    margin-bottom: 25px;
    white-space: normal;
  }
  h2 {
    font-weight: 700;
    font-size: 26px;
    white-space: normal;
  }
  li {
    margin-bottom: 20px;
    margin-left: 20px;
    white-space: normal;
  }
  a {
    color: ${(props) => props.theme.colors.text};
  }
  strong {
    font-weight: 700;
    opacity: 1;
  }
`

export const QrContainer = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 75px;
`

export const QrContainerBg = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 784px;
  min-height: 355px;
  padding: 52px 40px;
  margin: 0 auto 80px;
  background: ${(props) => props.theme.colors.qrCode.background};
`

export const QrWrapper = styled('div')<{ $isDisabled: boolean }>`
  position: relative;
  display: flex;
  width: 216px;
  height: 216px;
  opacity: ${(props) => (props.$isDisabled ? '0.1' : '1')};
`

export const QrWrapperMobileBg = styled('div')`
  position: relative;
  display: flex;
  width: 277px;
  height: 522px;
  padding: 98px 0 0;
  justify-content: center;
  background-image: url(${icons.register.qrMobileImg});
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
`

export const MediaPlayerBackground = styled.div<{ $isPopup?: boolean }>`
  width: 100vw;
  height: 100vh;
  background: #000;
  position: relative;
  ${({ $isPopup }) =>
    $isPopup &&
    css`
      position: absolute;
      z-index: 20;
      top: 0;
    `}
`

export const MediaPlayerWrapper = styled(FocusNode)`
  height: 100%;
`
